import React from "react";
import "./Testimonials.css";
import { Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import clinte1 from "../assets/testimonials/clinte 1.png";
import "swiper/css";
import "swiper/css/pagination";

const data = [
  {
    id: 1,
    image: clinte1,
    title: "Mohsen Ahmed",
    subtitle: "JavaScript-HTML-CSS Developer",
    comment:
      "Ahmed was fantastic to work with—detail-oriented, punctual, and proactive. He even sent me a prototype without being asked! A skilled and supportive engineer, I highly recommend him and look forward to working together again.",
    gigLink: "https://www.upwork.com/freelancers/~019568142f8d529137",
  },
];

const Testimonials = () => {
  return (
    <section className="testimonials container section" id="testimonials">
      <h2 className="section__title">Clients & Reviews</h2>

      <Swiper
        className="testimonials__container grid"
        // install Swiper modules
        modules={[Pagination]}
        spaceBetween={30}
        slidesPerView={1}
        loop={true}
        grabCursor={true}
        pagination={{ clickable: true }}
      >
        {data.map(({ id, image, title, subtitle, comment, gigLink }) => {
          return (
            <SwiperSlide className="testimonial__item" key={id}>
              <div className="thumb">
                <img src={image} alt="" />
              </div>
              <h3 className="testimonials__title">{title}</h3>
              <span className="subtitle">
                <small>
                  <a href={gigLink} target="_blank" rel="noopener noreferrer">
                    {subtitle}
                  </a>
                </small>
              </span>
              <div className="comment">{comment}</div>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </section>
  );
};

export default Testimonials;
